import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom/client'
import { Provider, connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import get from 'lodash/get'
import locale from './locale'
import { initializeTabContext } from './helpers/util'
import store from './store'
import App from './App'

initializeTabContext()
import * as serviceWorker from './serviceWorker'
import ApolloClientProvider from './apolloClient'

const RootComponent = props => {
  return (
    <ApolloClientProvider>
      <IntlProvider locale="en" messages={get(props, 'resources', locale.en)}>
        <Router>
          <Route
            exact
            path="/"
            render={() => <Redirect to={`/${context}`} />}
          />
          <Route path={`/${context}`} component={App} />
        </Router>
      </IntlProvider>
    </ApolloClientProvider>
  )
}

RootComponent.defaultProps = {
  resources: PropTypes.shape({}).isRequired
}

const mapStateToProps = state => {
  return {
    resources: get(state, 'resources', {})
  }
}

const ResourcedRootComponent = connect(mapStateToProps, null)(RootComponent)

const context = get(window, '__APP_ENV__.CONTEXT')
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <ResourcedRootComponent />
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
